import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { LclAdditionalShipmentPaymentModel, LCLShipmentModel } from '@data-layer/models/lcl';

@Injectable({
  providedIn: 'root',
})
export class AdditionalShipmentPaymentRepository {
  constructor(private apiService: ApiService) {}

  public create(charge: LclAdditionalShipmentPaymentModel, isShowLoader?: boolean): Observable<LCLShipmentModel> {
    return this.apiService.post<LCLShipmentModel>(`${environment.url.freight.additionalShipmentPayments}`, charge, null, {
      isShowLoader,
    });
  }
}
